module.exports = __webpack_public_path__ + "components/country-flag/static/as-a4f3e020c8fa8f0b31c9b5d7d90fc278.svg";